import React from "react";
import { LogOut, X } from "lucide-react";

interface LogoutPopupProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const LogoutPopup: React.FC<LogoutPopupProps> = ({ onConfirm, onCancel }) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div className="bg-background-paper dark:bg-background-paperDark rounded-lg shadow-lg w-full max-w-md p-6 relative">
      <button
        onClick={onCancel}
        aria-label="Close"
        className="absolute top-4 right-4 text-black/60 dark:text-text-secondaryDark hover:text-black dark:hover:text-white transition"
      >
        <X className="w-5 h-5" />
      </button>

      <div className="flex items-center justify-center mb-6">
        <div className="p-3 bg-background-panel dark:bg-background-paperDark/50 border border-divider/50 dark:border-white/15 rounded-lg">
          <LogOut className="w-8 h-8 text-black dark:text-text-primaryDark" />
        </div>
      </div>

      <h2 className="text-xl font-semibold text-center text-black dark:text-text-primaryDark mb-2">
        Confirm Logout
      </h2>

      <p className="text-sm text-center text-black/70 dark:text-text-secondaryDark mb-6">
        Confirm logout to end your session securely. You can log back in
        anytime.
      </p>

      <div className="flex justify-end gap-3">
        <button
          onClick={onCancel}
          className="px-5 py-2.5 rounded-md text-sm font-medium border border-black/12 dark:border-divider-dark bg-transparent text-black dark:text-white hover:bg-black/5 dark:hover:bg-white/5 transition-all duration-200"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className="px-5 py-2.5 rounded-md text-sm font-medium bg-black dark:bg-white text-white dark:text-black hover:bg-black/90 dark:hover:bg-white/90 transition-all duration-200"
        >
          Log Out
        </button>
      </div>
    </div>
  </div>
);

export default LogoutPopup;
